import { DocumentRenderer } from '@keystone-6/document-renderer';
import { GetServerSidePropsContext } from 'next';
import Container from '../components/container/container.component';
import Gallery from '../components/gallery/gallery.component';
import { getDownloads } from '../lib';
import styles from '../styles/downloads.module.scss';
import PageTemplate from '../templates/page.template';
import { Download } from '../types/download.interface';
import { Element } from '../types/element.type';
import { MappedOptions } from '../types/mapped-options-and-menus.interface';
import { Menu } from '../types/menu.interface';

interface Props {
  menu: Menu;
  options: MappedOptions;
  page: {
    title: string;
    content: { document: Element[] };
    description: string;
  };
  downloads: Download[];
}

const Downloads = ({ menu, options, downloads, page }: Props) => (
  <PageTemplate
    options={options}
    menu={menu}
    title={page.title}
    description={page.description}
  >
    <Container
      css={{ height: 'auto', minHeight: 'calc(100vh - 240px)' }}
      column={true}
    >
      <article className={styles.content}>
        <h1>{page.title}</h1>
        <DocumentRenderer document={page.content.document} />
        <Gallery
          images={downloads.map((download) => ({
            id: download.id,
            url: download.file.url,
            title: download.info,
            width: download.file.width,
            height: download.file.height,
          }))}
        />
      </article>
    </Container>
  </PageTemplate>
);

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const downloadPage = await getDownloads();

  ctx.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return {
    props: downloadPage,
  };
}

export default Downloads;
